import React from 'react';
import { SimpleFooter } from '../../footer/Footer';
import { AdminHeader } from '../plans/AdminHeader';
import { ReportsCourseAdminSection } from './ReportsCourseAdminSection';
/**
 * Creado por Equilibrio Agency 2022<br>
 * Página para mostrar contenido de sección usuarios
 * @return {HTMLElement} Elementos HTML de cada componente
 * @interface AdminHeader
 */
export const ReportsCourseAdminPage = () => {
  return (
    <>
      <AdminHeader />
      <div style={{ marginTop: '100px' }}></div>
      <ReportsCourseAdminSection />
      <SimpleFooter></SimpleFooter>
    </>
  );
};
